export default __webpack_public_path__ + "static/media/dots2.fa5f6f8e.svg";